import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { buergerportalAuthHeader } from "../components/BuergerPortalGate";

export default function BuergerPortalSitzung() {
  const { id } = useParams();
  const [sitzung, setSitzung] = useState(null);
  const [fehler, setFehler] = useState(false);

  useEffect(() => {
    fetch(`/api/oeffentlich/sitzungen/${id}`, { headers: buergerportalAuthHeader() })
      .then(r => {
        if (r.status === 401) { localStorage.removeItem("buergerportal_token"); window.location.reload(); return; }
        if (!r.ok) throw new Error();
        return r.json();
      })
      .then(d => d && setSitzung(d))
      .catch(() => setFehler(true));
  }, [id]);

  if (fehler) return <div style={{ padding: 40 }}>Diese Sitzung ist nicht öffentlich einsehbar.</div>;
  if (!sitzung) return <div style={{ padding: 40 }}>Wird geladen…</div>;

  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: 24 }}>
      <Link to="/buerger" style={{ fontSize: 13, color: "#666" }}>← Zurück zur Übersicht</Link>
      <h1 style={{ fontSize: 22, fontWeight: 700, marginTop: 8, marginBottom: 4 }}>{sitzung.titel}</h1>
      <div style={{ fontSize: 14, color: "#666", marginBottom: 24 }}>
        {sitzung.datum ? new Date(sitzung.datum).toLocaleDateString("de-DE", { day: "2-digit", month: "long", year: "numeric" }) : "Datum offen"}
      </div>

      <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>Tagesordnung</h2>
      {sitzung.tagesordnung.length === 0 && (
        <div style={{ color: "#999", fontSize: 13 }}>Keine öffentlichen Tagesordnungspunkte.</div>
      )}
      {sitzung.tagesordnung.map(top => (
        <div key={top.id} className="card" style={{ padding: 14, marginBottom: 6 }}>
          <span style={{ color: "#999", marginRight: 8 }}>TOP {top.position}</span>
          {top.titel}
        </div>
      ))}
    </div>
  );
}
